/**
 * ErrorService class skeleton from Covidpal app.
 * @author Ishu Sharma
 * this class is skeleton class from one of my projects. feel free to add to it.
 * #EIPP-561 added a ErrorBoundary class. IS
 */
export default class ErrorService {
    static onError(error) {
        // Send Error to Log Engine e.g LogRocket
        console.log(error);
    }

    static initHandler() {
        const scope = this;
        window.onerror = (message, url, lineNo, columnNo, error) => {
            if (error) {
                scope.onError(error);
                console.log(message, url, lineNo, columnNo, error);
            }
            return true;
        };
    }
}